module.exports = __webpack_public_path__ + "static/media/home_icon.88ed4d80.svg";